import { Slot } from '../hooks/useScheduling';
import { CheckCircle2, Calendar, Clock } from 'lucide-react';

interface SelectedSlotCardProps {
  slot: Slot | null;
}

export function SelectedSlotCard({ slot }: SelectedSlotCardProps) {
  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    const weekday = date.toLocaleDateString('pt-BR', { weekday: 'long' });
    const dateFormatted = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    return {
      date: `${weekday}, ${dateFormatted}`,
      time: date.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      }),
    };
  };

  if (!slot) {
    return (
      <div className="p-6 bg-muted/30 rounded-lg border-2 border-dashed border-border">
        <div className="flex items-center justify-center gap-2 text-muted-foreground">
          <Calendar className="w-5 h-5" />
          <p className="text-sm font-medium">Nenhum horário selecionado</p>
        </div>
        <p className="text-center text-xs text-muted-foreground/70 mt-2">
          Selecione um dia e horário para continuar
        </p>
      </div>
    );
  }

  const { date, time } = formatDateTime(slot.startTime);

  return (
    <div className="p-6 bg-gradient-to-r from-primary/5 to-primary/10 dark:from-primary/10 dark:to-primary/20 rounded-lg border-2 border-primary/20 dark:border-primary/30">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 bg-primary/10 dark:bg-primary/20 rounded-full flex items-center justify-center">
          <CheckCircle2 className="w-6 h-6 text-primary" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-3">Horário selecionado:</p>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 text-primary" />
              <p className="font-bold text-lg text-foreground capitalize">{date}</p>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-primary" />
              <p className="text-2xl font-bold text-primary">{time}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
